"use client";

import React from "react";
import { Facebook, Instagram, Linkedin, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-4 justify-center animate-pulse">
        <div className="h-4 w-20 bg-muted/20 rounded" />
        <div className="h-4 w-24 bg-muted/20 rounded" />
        <div className="h-4 w-16 bg-muted/20 rounded" />
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  const filteredItems = menuItems.filter(item => ["Home", "Studenti e Istituti", "Servizi Aziende", "Visti Turistici   Visti Consolari", "Visti e Immigrazione", "Documenti Import Export", "Blog", "Pratiche e Visti Online", "Contatti", "Privacy Policy"].includes(item.label));
  return <NavigationMenu viewport={false} className="mx-auto">
      <NavigationMenuList className="flex-wrap justify-center gap-x-6 gap-y-2">
        {filteredItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-secondary transition-colors font-default">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true
  });
  return <section ref={ref} data-section-id="239804" id="connessioni-globali" className={cn("relative bg-[#0A0A0F] text-primary-foreground overflow-hidden pt-24 pb-8 border-t border-[#00F5FF]/30 backdrop-blur-lg transition-all duration-700 ease-out", "shadow-[0_-10px_40px_-15px_rgba(0,245,255,0.3)]", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[30px]")}>
      {}
      <div className="absolute inset-0 pointer-events-none flex items-center justify-center opacity-[0.05] dark:opacity-[0.08] overflow-hidden select-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_watermark.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_watermark.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/world_immigration_watermark.png-wvc-sizes" alt="" className="w-[150%] min-w-[1000px] max-w-none object-contain" aria-hidden="true" loading="lazy" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 lg:gap-8 mb-20">
          {}
          <div className="lg:col-span-5 flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-7 w-auto" />
            </Link>
            <p className="text-muted-foreground text-base leading-relaxed max-w-md mb-8 font-default">
              WORLD IMMIGRATION DI DELGADO è il partner strategico per la mobilità internazionale. Offriamo consulenza premium per visti, immigrazione e servizi extragiudiziali con standard globali.
            </p>
            <div className="flex flex-col gap-2 text-sm text-muted-foreground font-default">
              <span>Via Lorenzo Ghiberti 21, 35134 Padova</span>
              <span>info@worldimmigration.it</span>
              <span>+39 049 86 40 662</span>
            </div>
          </div>

          {}
          <div className="lg:col-span-2 lg:col-start-7">
            <h4 className="font-default font-bold text-lg mb-6 tracking-wider text-secondary uppercase">
              Servizi
            </h4>
            <ul className="flex flex-col gap-4">
              <li data-index={0}>
                <Link to="/VisasAndImmigrationPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  Visti e Immigrazione
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/CompanyServicesPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  Servizi per Aziende
                </Link>
              </li>
              <li data-index={2}>
                <Link to="/StudentsAndInstitutesPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  Studenti e Istituti
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div className="lg:col-span-2">
            <h4 className="font-default font-bold text-lg mb-6 tracking-wider text-secondary uppercase">
              Azienda
            </h4>
            <ul className="flex flex-col gap-4">
              <li data-index={0}>
                <Link to="/ExtrajudicialPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  Extragiudiziali
                </Link>
              </li>
              <li data-index={1}>
                <Link to="/HomePage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  La Nostra Visione
                </Link>
              </li>
              <li data-index={2}>
                <Link to="/ContactsPage" className="text-muted-foreground hover:text-secondary transition-colors text-sm font-default">
                  Lavora con Noi
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {}
        <div className="mb-12 border-t border-secondary/10 pt-8">
          <MenuProvider menu_id="17">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-6 pt-8 border-t border-secondary/10">
          <p className="text-sm text-muted-foreground font-default font-medium tracking-wide">
            Eccellenza Globale. &copy; {new Date().getFullYear()} WORLD IMMIGRATION DI DELGADO.
          </p>
          
          <div className="flex items-center gap-2">
            <Button variant="ghost" size="icon" asChild className="rounded-lg text-secondary grayscale transition-all duration-300 hover:grayscale-0 hover:scale-120 hover:shadow-[0_0_15px_rgba(0,245,255,0.4)] hover:bg-transparent">
              <Link to="#" aria-label="Instagram">
                <Instagram className="size-4" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="rounded-lg text-secondary grayscale transition-all duration-300 hover:grayscale-0 hover:scale-120 hover:shadow-[0_0_15px_rgba(255,0,229,0.4)] hover:bg-transparent">
              <Link to="#" aria-label="Twitter">
                <Twitter className="size-4" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="rounded-lg text-secondary grayscale transition-all duration-300 hover:grayscale-0 hover:scale-120 hover:shadow-[0_0_15px_rgba(0,245,255,0.4)] hover:bg-transparent">
              <Link to="#" aria-label="Facebook">
                <Facebook className="size-4" />
              </Link>
            </Button>
            <Button variant="ghost" size="icon" asChild className="rounded-lg text-secondary grayscale transition-all duration-300 hover:grayscale-0 hover:scale-120 hover:shadow-[0_0_15px_rgba(255,0,229,0.4)] hover:bg-transparent">
              <Link to="#" aria-label="LinkedIn">
                <Linkedin className="size-4" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}